(function () {
  var MAX_CARDS = 8;
  var POLL_MS = 80;
  var POLL_FOR = 8000;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDate(unix) {
    if (!unix) return '';
    try {
      return new Date(Number(unix) * 1000).toLocaleDateString('en-AU', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    } catch (e) {
      return '';
    }
  }

  function starsHtml(rating) {
    var full = Math.round(Number(rating) || 0);
    if (full < 0) full = 0;
    if (full > 5) full = 5;
    var html = '';
    var i;
    for (i = 1; i <= 5; i++) {
      html += '<span class="ka-gr-native__star' + (i <= full ? ' is-full' : '') + '" aria-hidden="true">★</span>';
    }
    return html;
  }

  function pushReview(out, name, body, rating, date) {
    if (!body) return;
    if (out.length >= MAX_CARDS) return;
    out.push({
      name: name || 'Google reviewer',
      text: body,
      rating: rating || 5,
      date: date || '',
    });
  }

  function reviewsFromMeta(meta) {
    var list = meta && meta.reviews;
    var out = [];
    var i;
    var review;
    var body;
    if (!list || !list.length) return out;
    for (i = 0; i < list.length; i++) {
      review = list[i];
      if (!review || typeof review !== 'object') continue;
      body = review.text ? String(review.text).trim() : '';
      pushReview(
        out,
        review.author_name ? String(review.author_name).trim() : 'Google reviewer',
        body,
        review.rating,
        formatDate(review.time)
      );
    }
    return out;
  }

  function reviewsFromWidget(section) {
    var nodes = section.querySelectorAll('.grp-entangle-item');
    var out = [];
    var i;
    var node;
    var nameEl;
    var textEl;
    var dateEl;
    var body;
    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      nameEl = node.querySelector('.grp-entangle-item-head-name');
      textEl = node.querySelector('.grp-entangle-item-body-review');
      dateEl = node.querySelector('.grp-entangle-item-date');
      body = textEl ? String(textEl.textContent || '').replace(/\s*Read\s+(More|Less)\s*/gi, ' ').trim() : '';
      pushReview(
        out,
        nameEl ? String(nameEl.textContent || '').trim() : 'Google reviewer',
        body,
        5,
        dateEl ? String(dateEl.textContent || '').trim() : ''
      );
    }
    return out;
  }

  function collectReviews(section) {
    var fromMeta = reviewsFromMeta(window.grp_app_metadata);
    if (fromMeta.length) {
      window.__kaGoogleReviewsCache = fromMeta;
      return fromMeta;
    }
    var fromWidget = reviewsFromWidget(section);
    if (fromWidget.length) {
      window.__kaGoogleReviewsCache = fromWidget;
      return fromWidget;
    }
    return window.__kaGoogleReviewsCache || [];
  }

  function fillBadge(section, meta) {
    if (!meta) return;
    var score = section.querySelector('[data-ka-gr-score]');
    var count = section.querySelector('[data-ka-gr-count]');
    var link = section.querySelector('[data-ka-gr-link]');
    var stars = section.querySelector('[data-ka-gr-stars]');
    if (score && meta.rating) {
      score.textContent = meta.rating;
      score.hidden = false;
    }
    if (stars && meta.rating) {
      stars.hidden = false;
      stars.setAttribute('aria-label', meta.rating + ' out of 5 on Google');
    }
    if (count && meta.total_num_of_reviews != null && meta.total_num_of_reviews !== '') {
      count.textContent = meta.total_num_of_reviews + ' Google reviews';
      count.hidden = false;
    }
    if (link && meta.url) {
      link.setAttribute('href', meta.url);
      link.hidden = false;
    }
  }

  function bindTrack(track, prev, next) {
    if (!track) return;

    function cardStep() {
      var card = track.querySelector('.ka-gr-native__card');
      if (!card) return 280;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function render(section, items) {
    var mount = section.querySelector('[data-ka-google-reviews]');
    var cards = '';
    var i;
    var item;
    if (!mount || !items.length) return false;
    if (mount.getAttribute('data-ka-gr-rendered') === String(items.length)) return true;

    for (i = 0; i < items.length; i++) {
      item = items[i];
      cards +=
        '<li class="ka-gr-native__card">' +
          '<p class="ka-gr-native__stars" role="img" aria-label="' +
          escapeHtml(item.rating) +
          ' out of 5">' +
          starsHtml(item.rating) +
          '</p>' +
          '<blockquote class="ka-gr-native__quote">' +
          escapeHtml(item.text).replace(/\n/g, '<br>') +
          '</blockquote>' +
          '<div class="ka-gr-native__meta">' +
            '<p class="ka-gr-native__author">' +
            escapeHtml(item.name) +
            '</p>' +
            (item.date ? '<p class="ka-gr-native__date">' + escapeHtml(item.date) + '</p>' : '') +
          '</div>' +
        '</li>';
    }

    mount.innerHTML =
      '<div class="ka-gr-native">' +
        '<div class="ka-gr-native__viewport">' +
          '<ul class="ka-gr-native__track" role="list">' +
          cards +
          '</ul>' +
        '</div>' +
        '<div class="ka-gr-native__controls">' +
          '<button type="button" class="ka-gr-native__nav" data-ka-gr-prev aria-label="Previous reviews">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="18" height="18" aria-hidden="true"><path d="M15 5 8 12l7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
          '<button type="button" class="ka-gr-native__nav" data-ka-gr-next aria-label="Next reviews">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="18" height="18" aria-hidden="true"><path d="m9 5 7 7-7 7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';

    mount.setAttribute('data-ka-gr-rendered', String(items.length));
    bindTrack(
      mount.querySelector('.ka-gr-native__track'),
      mount.querySelector('[data-ka-gr-prev]'),
      mount.querySelector('[data-ka-gr-next]')
    );
    return true;
  }

  function boot(section) {
    var items;
    fillBadge(section, window.grp_app_metadata);
    items = collectReviews(section);
    if (!items.length) return false;
    if (!render(section, items)) return false;
    section.classList.add('ka-google-reviews--native-ready');
    section.classList.remove('ka-google-reviews--fallback');
    return true;
  }

  function watchMount(section) {
    var mount = section.querySelector('[data-ka-google-reviews]');
    if (!mount || mount.getAttribute('data-ka-gr-observed') === 'true') return;
    mount.setAttribute('data-ka-gr-observed', 'true');
    new MutationObserver(function () {
      if (!section.classList.contains('ka-google-reviews--native-ready')) return;
      if (mount.querySelector('.ka-gr-native__card')) return;
      mount.removeAttribute('data-ka-gr-rendered');
      section.classList.remove('ka-google-reviews--native-ready');
      section.removeAttribute('data-ka-gr-bound');
      initSection(section);
    }).observe(mount, { childList: true, subtree: true });
  }

  function initSection(section) {
    if (!section) return;
    if (section.classList.contains('ka-google-reviews--native-ready') &&
        section.querySelector('.ka-gr-native__card')) {
      return;
    }
    if (section.getAttribute('data-ka-gr-bound') === 'true') return;
    section.setAttribute('data-ka-gr-bound', 'true');
    watchMount(section);
    if (boot(section)) return;

    var started = Date.now();
    var timer = setInterval(function () {
      if (boot(section) || Date.now() - started > POLL_FOR) {
        clearInterval(timer);
        if (!section.classList.contains('ka-google-reviews--native-ready')) {
          section.classList.add('ka-google-reviews--fallback');
          section.removeAttribute('data-ka-gr-bound');
        }
      }
    }, POLL_MS);
  }

  function init(root) {
    var scope = root || document;
    var sections;
    var i;
    if (scope && scope.classList && scope.classList.contains('ka-google-reviews--has-app')) {
      initSection(scope);
      return;
    }
    sections = scope && scope.querySelectorAll ? scope.querySelectorAll('.ka-google-reviews--has-app') : [];
    for (i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  window.kaGoogleReviewsInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var nested;
    if (!target) return;
    if (target.classList && target.classList.contains('ka-google-reviews')) {
      target.removeAttribute('data-ka-gr-bound');
      init(target);
      return;
    }
    if (target.querySelector) {
      nested = target.querySelector('.ka-google-reviews');
      if (nested) {
        nested.removeAttribute('data-ka-gr-bound');
        init(nested);
      }
    }
  });
})();
